module.exports = __webpack_public_path__ + "static/media/mouse.284db968.png";